export default class SingletonService {
    static makeSingleton(makeValue) {
        let val;
        return () => {
            if (!val) {
                val = makeValue();
            }
            return val;
        };
    }
}
